"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressNotFoundException = void 0;
const http_exception_1 = require("../http.exception");
class AddressNotFoundException extends http_exception_1.HttpException {
    constructor(reason) {
        super(404, `Address not found: ${reason}`);
    }
}
exports.AddressNotFoundException = AddressNotFoundException;
//# sourceMappingURL=addressNotFound.exception.js.map